import * as moment from 'moment'

export default {
  methods: {
    getDateDefauld (date) {
      return moment(date).format('DD MMM YYYY')
    },
    getDateFormat1 (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    getDateFormat2 (date) {
      return moment(date).format('DD MMMM YYYY')
    },
    getTimeFormat1 (date) {
      return moment(date).format('hh:mm A')
    },
    getFullDate (date) {
      return moment(date).format('MMMM Do YYYY')
    },
    getTime12 (date) {
      return moment(date).format('hh:mm A')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getters/date-time.js